export const SERVICE_CENTER_PHONE_DISPLAY = '+49 (0)30 221 835 400'
export const SERVICE_CENTER_PHONE_TEL = '+49030221835400'
